export const CHANGE_LANGUAJE = "CHANGE_LANGUAJE";
export const SPANISH = "spanish";
export const ENGLISH = "english";
